import { fetchAuthSession, signOut } from 'aws-amplify/auth';
// Attach the Cognito session JWT to a sales-api call. `sales-api` is fronted by
// an API Gateway Cognito authorizer. When the refresh token has expired we sign
// the salesperson out so the Amplify Authenticator surfaces the login screen
// instead of stranding the UI with an opaque "not authenticated" error.
export const authHeader = async () => {
    try {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();
        if (!idToken) {
            await signOut();
            throw new Error('session expired');
        }
        return { Authorization: `Bearer ${idToken}` };
    }
    catch (err) {
        await signOut().catch(() => undefined);
        throw err instanceof Error ? err : new Error('session expired');
    }
};
// The configured sales-api base URL, trailing slash trimmed.
export const salesApiBaseUrl = () => {
    const fromEnv = process.env.SALES_API_BASE_URL;
    if (!fromEnv) {
        throw new Error('SALES_API_BASE_URL is not configured');
    }
    return fromEnv.replace(/\/$/, '');
};
